import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX';

export enum PATHS {
    Home = `${BELIMO_HASH_PREFIX}/`,
    UserInput = `${BELIMO_HASH_PREFIX}/input`,
    Valves = `${BELIMO_HASH_PREFIX}/valves`,
    ValvesFilter = `${BELIMO_HASH_PREFIX}/valves-filter`,
    Actuators = `${BELIMO_HASH_PREFIX}/actuators`,
    ActuatorsFilter = `${BELIMO_HASH_PREFIX}/actuators-filter`,
    Accessories = `${BELIMO_HASH_PREFIX}/accessories`,
    Checkout = `${BELIMO_HASH_PREFIX}/checkout`,
    Share = `${BELIMO_HASH_PREFIX}/share`,
}
